// extracted by mini-css-extract-plugin
export var editInput = "_gy-0";
export var editInputCompact = "_gy-2";
export var editInputLarge = "_gy-1";
export var editInputSmall = "_gy-3";